import React from 'react';
import { OutlinedTextFieldProps } from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles, useTheme } from '@material-ui/core';
import TextField from '../../styles/templates/DSTextField';

import TooltipImg from '../../assets/Tooltip';
import { DSTheme } from '../../styles/themes/types';

interface PropsType extends OutlinedTextFieldProps {
  tooltipText: string;
  card?: boolean;
  wide?: boolean;
}

const useTooltipStyles = makeStyles((theme: DSTheme) => ({
  input: {
    position: 'relative',
    width: 'fit-content',
  },
  tooltipWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    right: '15px',
    top: '-12px',
    zIndex: 5,
    width: '30px',
    backgroundColor: theme.palette.background.default,

    '&.card': {
      backgroundColor: theme.palette.background.elevation1,
    },

    '&.wide': {
      right: '25px',
    },
  },
  arrow: {
    color: theme.palette.primary.contrastText,
    fontSize: '32px',
  },
  tooltipArrow: {
    marginRight: '-10px',
  },
  tooltip: {
    backgroundColor: theme.palette.primary.contrastText,
    borderRadius: '16px',
    color: theme.palette.text.tooltip,
    fontSize: '12px',
    lineHeight: '16px',
    padding: '32px',
    maxWidth: '166px',
    boxShadow: '0px 5px 45px rgba(0,0,0,0.18)',
  },
}));

const TooltipInput: React.FC<PropsType> = ({ tooltipText, card, wide, ...rest }) => {
  const classes = useTooltipStyles();
  const theme = useTheme();

  return (
    <div className={classes.input}>
      <Tooltip
        title={tooltipText}
        placement="top-end"
        arrow
        classes={{
          arrow: classes.arrow,
          tooltip: classes.tooltip,
          tooltipArrow: classes.tooltipArrow,
        }}
      >
        <div className={`${classes.tooltipWrapper} ${card ? 'card' : ''} ${wide ? 'wide' : ''}`}>
          <TooltipImg stroke={theme.palette.text.primary} />
        </div>
      </Tooltip>
      <TextField {...rest} />
    </div>
  );
};

export default TooltipInput;
